import {FormViewMode} from '@macmillanplatform/ui-core';

import {SectionContentItem} from '../../types';

import './index.css';

const DetailsSubSection = (props: SectionContentItem) => {
  const {subHeading, values} = props;

  return (
    <div className="DetailsSubSection__container">
      {subHeading && <h3>{subHeading}</h3>}
      <div className="DetailsSubSection__content">
        {values.map(({value, label}, index) => (
          <FormViewMode
            key={`${index}-${value}-${label}`}
            value={value}
            label={label}
          />
        ))}
      </div>
    </div>
  );
};

export default DetailsSubSection;
